import React from 'react';
import { useParams } from 'react-router-dom';

import Box from '@mui/material/Box';

import RichHtmlText from '@ts-core/core/components/RichHtmlText';

import { useActivity } from '../../hooks';

const ActivityStatementPage = () => {
  const { courseId, activityId } = useParams<{ courseId: string; activityId: string }>();
  const { activity, loading } = useActivity({ courseId, activityId });

  return (
    <Box border="1px solid rgba(0, 0, 0, 0.2)" borderRadius={4} p={2}>
      <RichHtmlText content={activity?.statement} loading={loading} />
    </Box>
  );
};

export default ActivityStatementPage;
